import type {
  Company,
  Role,
  User,
  UserGroup,
  UserStatus,
  UserType,
} from 'api/models';
import type { FieldValue, FieldValueType } from 'api/tasks';
import { TimeoffResponse } from 'api/timeoff/types';
import { Minutes } from 'components/organisms/user-capacity/types';

/* This is a 'physical' class that is mapped to
 * the user table. We can have methods on it that
 * we could call on retrieved database objects.
 */
export class Member implements User {
  firstName?: string | undefined;

  lastName?: string | undefined;

  emailId: string;

  userId: number;

  photoUrl?: string | undefined;

  userType: UserType;

  company: Company;

  role?: Role | undefined;

  userStatus: UserStatus;

  timeZone?: string | undefined;

  fields?: FieldValue<FieldValueType>[] | undefined;

  defaultCapacity: boolean;

  capacityMinutes: Minutes;

  projectIds?: number[] | undefined;

  userTimeOffDetails?: TimeoffResponse[];

  userGroups: UserGroup[];

  holidayCalendarId?: number;

  constructor(user: User) {
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.emailId = user.emailId;
    this.userId = user.userId;
    this.photoUrl = user.photoUrl;
    this.userType = user.userType;
    this.company = user.company;
    this.role = user.role;
    this.userStatus = user.userStatus;
    this.timeZone = user.timeZone;
    this.fields = user.fields;
    this.defaultCapacity = user.defaultCapacity;
    this.capacityMinutes = user.capacityMinutes;
    this.userTimeOffDetails = user?.userTimeOffDetails;
    this.userGroups = user.userGroups;
    this.holidayCalendarId = user?.holidayCalendarId;
  }
}
